export const ADMIN_OVERVIEW_GRID =
  "grid grid-cols-1 gap-md p-xl md:gap-xl lg:grid-cols-2 xl:grid-cols-4";

export const ADMIN_RECENT_INVOICES_CELL =
  "order-last rounded-xl border border-border-secondary bg-bg-primary px-3xl py-xl lg:order-none lg:col-span-2 xl:col-span-3";

export const ADMIN_SIDE_COLUMN =
  "flex flex-col gap-md md:gap-xl lg:col-span-2 lg:grid lg:grid-cols-2 xl:col-span-1 xl:flex";
